import React from "react";


export const ExeCycle = (props) => {
    return (
        <div>
            <div className="inly-sutit">운동 주기</div>
            <div>
                <input type="text" className="textbox open-exercise-cycle excyc-result" placeholder="운동 주기를 설정하세요." readOnly />
            </div>
        </div>
    );
};

export const ExeDate = () => {
    return(
        <div>
            <div className="inly-sutit">운동 날짜</div>
            <div>
                <input type="text" className="textbox open-today-dateset td-date-result" placeholder="" defaultValue="2020-10-03(수)" readOnly="" />
            </div>
        </div>
    );
}

export const ExeTime = (props) => {
    return(
        <div>
            <div className="inly-sutit">운동 시간</div>
            <div>
                <div className="select-custom-box in5">
                    <a className="btn-select inb">30분</a>
                    <ul>
                        <li><a>10분</a></li>
                        <li><a>20분</a></li>
                        <li><a>30분</a></li>
                        <li><a>40분</a></li>
                        <li><a>50분</a></li>
                        <li><a>60분</a></li>
                    </ul>
                </div>
            </div>
        </div>
    );
}